<template>
  <div id="MtrComponentGroup" class="q-pa-md">
    <div class="text-h6 q-mx-md q-my-sm">{{ name }}</div>
    <div class="row">
      <div class="col-2 q-ma-sm" v-if="mtrs">
        <q-list class="buttons-list">
          <q-item
            v-for="item in mtrs"
            :key="item"
            clickable
            v-ripple
            :active="mtr === item"
            @click="changeMtrComponentSelect(item)"
            active-class="itemSelect"
            class="item q-pa-md q-ma-sm shadow-1"
          >
            <q-item-section class="ellipsis">
              {{ $gettext(item.name) }}</q-item-section
            >
          </q-item>
        </q-list>
      </div>
      <q-card class="col-9 q-ma-md no-padding">
        <span v-for="item in mtrs" :key="item">
          <q-card-section v-if="mtr === item" class="padding-crud">
            <crud-layout-search
              :ref="'crudLayoutSearch-' + item.name"
              :name="$gettext(item.name)"
              :interface="item.interface"
              :page="item.page"
              :id="id"
              clean-layout
            >
              <page-table
                slot="page-table"
                slot-scope="dataPageTable"
                v-bind="dataPageTable"
                @action-button="dataPageTable.actionButton"
                @show-message="dataPageTable.showMessage"
              >
                <jt-data-table
                  slot="table"
                  slot-scope="dataTable"
                  v-bind="dataTable"
                  singleselect
                  class="table-crud"
                  :row-buttons="true"
                  @selection="dataTable.selection"
                  @action-button="dataTable.actionButton"
                  @show-message="dataTable.showMessage"
                  @toggle-change="row"
                >
                </jt-data-table>
              </page-table>
            </crud-layout-search>
          </q-card-section>
        </span>
      </q-card>
    </div>
  </div>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import { JtCrud, JtDataTable } from 'jtech-webcomps'
import TemporaryStorage from './temporary-storage/TemporaryStorage.vue'
const { CrudLayoutSearch, pageTable } = JtCrud

@Component({
  name: 'MtrComponentGroup',
  components: {
    CrudLayoutSearch,
    pageTable,
    JtDataTable
  },
  props: {
    id: String,
    interface: String,
    name: String
  }
})
class MtrComponentGroup extends Vue {
  mtrs = [];
  mtr = '';
  indice = 0;

  beforeMount () {
    this.mtrs = [
      {
        name: 'PACKAGING',
        interface: 'packaging.pesquisar',
        page: null
      },
      {
        name: 'PACKAGING_PHYSICAL_STATE',
        interface: 'packagingPhysicalState.pesquisar',
        page: null
      },
      {
        name: 'TEMPORARY_STORAGE',
        interface: 'temporaryStorage.pesquisar',
        page: TemporaryStorage
      },
      {
        name: 'ENVIRONMENTAL_AGENCY_CLASS_AND_RESIDUE',
        interface: 'environmentalAgencyClassAndResidue.pesquisar',
        page: null
      },
      {
        name: 'ENVIRONMENTAL_AGENCY_RESIDUE_CLASSIFICATION',
        interface: 'environmentalAgencyResidueClassification.pesquisar',
        page: null
      },
      {
        name: 'PHYSICAL_STATE',
        interface: 'physicalState.pesquisar',
        page: null
      },
      {
        name: 'PACKING_GROUP',
        interface: 'packingGroup.pesquisar',
        page: null
      },
      {
        name: 'SHIPPING_NAME',
        interface: 'shippingName.pesquisar',
        page: null
      },
      {
        name: 'ENVIRONMENTAL_AGENCY_RESIDUE',
        interface: 'environmentalAgencyResidue.pesquisar',
        page: null
      },
      {
        name: 'ENVIRONMENTAL_AGENCY_TREATMENT_TYPE',
        interface: 'environmentalAgencyTreatmentType.pesquisar',
        page: null
      },
      {
        name: 'ENVIRONMENTAL_AGENCY_MEASUREMENT_UNIT',
        interface: 'environmentalAgencyMeasurementUnit.pesquisar',
        page: null
      }
    ]
    this.mtr = this.mtrs[0]
  }

  changeMtrComponentSelect (item) {
    this.mtr = item
  }
}
export default MtrComponentGroup
</script>
<style lang="stylus" scoped>
@import '~quasar-variables';

#MtrComponentGroup {
.buttons-top-crud{
    margin-top: 5px;
    margin-bottom: -3px;
  }

::v-deep {
  .jt-crud-container {
    padding: 0%;
  }
}

.padding-crud{
     padding: 0px 10px 10px;
     margin-top: -15px;
   }

    .itemSelect{
     color: white;
     background: $secondary!important;
     border-left: 5px solid $dark!important;
     padding-left: 5%!imporant;
   }

   .item{
     background: white;
     font-weight: 500;
     padding-left: 10%;
     font-size: 1rem;
   }
 }
</style>
